<template lang="html">
  <transition
    :duration="300"
    name="fade"
  >
    <div
      v-show="visible"
      class="price-modal"
      @click="close"
    >
      <section class="window">
        <slot />
        <footer>
          <span
            href="#"
            @click="$emit('close')"
          >Close</span>
        </footer>
      </section>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close(e) {
      if (!this.$el.querySelector('.window').contains(e.target)) this.$emit('close');
    },
  },
};
</script>

<style lang="stylus">

.price-modal
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(0,0,0,0.7)
  z-index: 3
  display: flex
  align-items: center
  justify-content: center

  &.fade-enter-active,
  &.fade-leave-active
    transition: background-color 300ms ease

    .window
      transition: transform 300ms ease, opacity 200ms ease

  &.fade-enter,
  &.fade-leave-to
    background-color: transparent

    .window
      transform: translateY(5%)
      opacity: 0

  @media only screen and (max-width: 425px)
    align-items: flex-end

  .window
    width: 50%
    max-height: 80%
    overflow: auto
    background-color: white
    border-radius: 4px
    box-shadow: 0 0 8px rgba(0,0,0,0.1), 0 8px 32px rgba(0,0,0,0.2)
    padding: 32px
    color: rgba(0,0,0,0.87)

    @media only screen and (max-width: 425px)
      width: 100%
      max-height: 80%
      border-bottom-left-radius: 0
      border-bottom-right-radius: 0
      box-shadow: 0 0 8px rgba(0,0,0,0.1), 0 -8px 32px rgba(0,0,0,0.2)

    footer
      text-align: right
      margin-top: 16px

      span
        color: rgba(0,0,0,0.5)
        font-family: 'Montserrat', sans-serif
        font-weight: 900
        padding: 16px 8px
        text-decoration: none
        cursor: pointer
        transition: color 200ms ease

        &:hover
          color: black

    article
      columns: 3

      @media only screen and (max-width: 1024px)
        columns: 2

      @media only screen and (max-width: 425px)
        columns: 1

    h1,
    h2
      font-size: 2rem
      text-transform: uppercase
      font-family: 'Montserrat', sans-serif
      font-weight: 900
      margin-top: 0

    h1
      column-span: all
      margin-bottom: 1.5rem

    h1 + h2
      margin-top: 0

    h2
      font-size: 1rem
      margin-top: 1.5rem
      line-height: 1.5
      margin-bottom: 0

    p
      margin-top: 0
      margin-bottom: 1.5rem
      line-height: 1.5

    a
      color: inherit

    ul
      margin: 0
      padding-left: 20px

      li
        line-height: 1.5

</style>
